import { styled, css } from "styled-components";
import Colors from "../../styles/Colors";
import { mediaQueries } from "../../styles";
export const Price = styled.h3 `
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: ${Colors.PROFILE_RED_2024};
`;
export const PriceAnimationDiv = styled.div `
  display: flex;
  > div {
    margin-top: -1.25rem;
    height: 70px;
    width: 150px;
    margin-bottom: -1.26rem;
    > svg  {
      padding: 10px;
      margin-left: -1rem;

    }
    > h3 {
      position: absolute;
    }
  }
`;
export const PriceAnimationForMobileDiv = styled.div `
  display: flex;
  > div {
    margin-top: -1.25rem;
    width: 100px;
  > svg {
      padding-top: 1rem;
      padding-left: -20px;
      margin-left: -0.5rem;
      margin-bottom: -0.5rem;
  }
    > h3 {
      position: absolute;
      padding-right: 0;
      padding-left: 8px;
      font-weight: 700;
      line-height: 26px;
      font-size: 20px;
      color: ${Colors.PROFILE_RED_2024};
    }
  }
`;
export const Header = styled.h3 `
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: ${Colors.BLACK_2024};
`;
export const SubHeader = styled.h3 `
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  color: ${Colors.BLACK_2024};

  ${mediaQueries.down("belowMedium") `
  font-size: 20px;
  line-height: 26px;
  `}
`;
export const TravelInfoWrapper = styled.div `
  max-width: 330px;
  width: 100%;

  background: ${(props) => props.bgColor || Colors.DARK_WHITE_2024};
  padding: 1.125rem 1.125rem 1rem 1.125rem;
  border-radius: 5px;

  ${(props) => props.variant === "fullWidth" &&
    css `
      max-width: 100%;

      ${mediaQueries.down("belowMedium") `
      padding: 0rem 1.125rem 1.5rem 1.125rem;
        ${Price} {
          display: none;
        }
        ${PriceAnimationDiv} {
           display: none;
        }
        ${Header} {
          display: none;
          padding: 0;
        }
      `}
    `}
`;
export const Date = styled.p `
  color: ${Colors.BLACK_2024};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;

  ${mediaQueries.down("belowMedium") `
    font-size: 16px;
    line-height: 24px;
  `}
`;
export const IconTextButtonWrapper = styled.div `
  color: ${Colors.BLACK_2024};
  margin-bottom: 0.5rem;

  > button {
    color: ${Colors.BLACK_2024};
    font-weight: 400;
    text-align: left;

    ${mediaQueries.down("belowMedium") `
     font-size: 16px;
     line-height: 24px;
     padding-top: 1px;
     padding-bottom: 1px;

  `}
  }
`;
export const MainItem = styled.div `
  border-top: 1px solid rgba(255, 255, 255, 0.2);

  margin: 24px -20px;
  padding: 0px 20px;
  ${(props) => props.variant === "fullWidth" &&
    css `
      margin: 24px -20px;
    `}

  ${mediaQueries.down("belowMedium") `
    margin: 24px 4px;
    padding: 0px 4px;
  &:first-child {
    border-top: 0;
  }
`}
`;
//# sourceMappingURL=SummaryBox.styles.js.map